import methods from '@/enums/methods'
import ThothV2 from '../base/thothV2'

class LiquidationService extends ThothV2 {
  getLiquidation({ date }) {
    return this.api({
      url: '/arrangement-liquidations', 
      method: methods.GET,
      params: {
        startDate: date,
        endDate: date,
      },
    })
  }

  sendCreditRequest({ date }) {
    return this.api({
      url: '/liquidation/credit-request', 
      method: methods.POST,
      data: {
        date,
      },
    })
  }

  sendDebitRequest({ date }) {
    return this.api({
      url: '/liquidation/debit-request', 
      method: methods.POST,
      data: {
        date,
      },
    })
  }

  sendAutomaticAntecipationRequest({ date }) {
    return this.api({
      url: '/liquidation/automatic-antecipation-request',
      method: methods.POST,
      data: {
        date,
      },
    })
  }

  sendManualAntecipationRequest({ date }) {
    return this.api({
      url: '/liquidation/manual-antecipation-request',
      method: methods.POST,
      data: {
        date,
      },
    })
  }
}

export default new LiquidationService()